"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { LOCALES, LOCALE_LABELS, type Locale } from "@/lib/i18n/dictionaries";
import { useI18n } from "@/components/i18n-provider";
import { cn } from "@/lib/utils";

const LOCALE_COOKIE = "locale";

export function LanguageToggle() {
  const { locale } = useI18n();
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  function choose(l: Locale) {
    if (l === locale) return;
    document.cookie = `${LOCALE_COOKIE}=${l}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
    startTransition(() => router.refresh());
  }

  const next = () => choose(LOCALES[(LOCALES.indexOf(locale) + 1) % LOCALES.length]);

  return (
    <>
      {/* Телефон: одна кнопка, языки переключаются по кругу — три кнопки
          рядом с темой и аватаром не помещаются в 390 px. */}
      <button
        type="button"
        onClick={next}
        aria-label={LOCALE_LABELS[locale]}
        className={cn(
          "flex h-9 w-11 items-center justify-center rounded-lg border bg-background text-xs font-semibold shadow-sm transition-colors hover:text-foreground sm:hidden",
          pending && "opacity-60",
        )}
      >
        {LOCALE_LABELS[locale]}
      </button>

    <div
      className={cn(
        "hidden items-center rounded-lg border bg-background p-0.5 text-xs font-medium shadow-sm sm:flex",
        pending && "opacity-60",
      )}
    >
      {LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => choose(l)}
          aria-pressed={l === locale}
          className={cn(
            "rounded-md px-2 py-1 transition-colors",
            l === locale ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground",
          )}
        >
          {LOCALE_LABELS[l]}
        </button>
      ))}
    </div>
    </>
  );
}
